"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../utils/helpers");

var _ListStyled = require("./List-styled");

var _List = require("./List");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ListItem = function ListItem(_ref) {
  var children = _ref.children,
      leftNode = _ref.leftNode,
      rightNode = _ref.rightNode,
      active = _ref.active,
      filterItem = _ref.filterItem,
      onClick = _ref.onClick,
      other = _objectWithoutProperties(_ref, ["children", "leftNode", "rightNode", "active", "filterItem", "onClick"]);

  var listContext = (0, _react.useContext)(_List.ListContext);

  var getLeftNode = function getLeftNode(leftNode) {
    if (leftNode) {
      return _react.default.createElement(_ListStyled.StyledListSideContainer, {
        minimal: listContext.minimal,
        selectable: listContext.selectable,
        nested: listContext.nested,
        active: active
      }, leftNode);
    }
  };

  var getRightNode = function getRightNode(rightNode) {
    if (rightNode) {
      return _react.default.createElement(_ListStyled.StyledListSideContainer, {
        minimal: listContext.minimal,
        selectable: listContext.selectable,
        nested: listContext.nested,
        active: active
      }, rightNode);
    }
  };

  return _react.default.createElement(_ListStyled.StyledListItem, _extends({
    minimal: listContext.minimal,
    multiSelect: listContext.multiSelect,
    selectable: listContext.selectable,
    nested: listContext.nested,
    filterItem: filterItem,
    active: active,
    tabIndex: "0",
    role: "listitem"
  }, (0, _helpers.getAccessibleOnClickHandlers)(onClick), other), getLeftNode(leftNode), _react.default.createElement(_ListStyled.StyledListTextContainer, null, children), getRightNode(rightNode));
};

ListItem.propTypes = {
  /** Content of the ListItem. */
  children: _propTypes.default.node,

  /** Content placed to the left of the ListItem. */
  leftNode: _propTypes.default.node,

  /** Content placed to the right of the ListItem. */
  rightNode: _propTypes.default.node,

  /** Toggle the active style of a ListItem */
  active: _propTypes.default.bool,

  /** Add some styles to display a Search element properly inside a ListItem  */
  filterItem: _propTypes.default.bool,

  /** Toggle the disabled state of the ListItem, results in the item being unselectable and slightly lower opacity */
  disabled: _propTypes.default.bool
};
ListItem.defaultProps = {};
ListItem.displayName = 'ListItem';
var _default = ListItem;
exports.default = _default;